// The regular consultation links work without this optional mobile shortcut.
(() => {
  const shortcut = document.querySelector('[data-xsto-mobile-contact]');
  const primary = document.querySelector('[data-xsto-primary-contact]');
  if (!shortcut || !primary || !('IntersectionObserver' in window)) return;
  const footer = document.querySelector('.xsto-footer');
  const visible = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    shortcut.hidden = visible.size > 0;
  });
  observer.observe(primary);
  if (footer) observer.observe(footer);
})();
